// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AccountMenu-cls1__e230c279e0c12204ac43{/*!*/}.AccountMenu-cls2___c8b461cb4c906851c23{min-width:100%;margin:0;padding:5px 8px;padding-left:36px;display:flex;justify-content:space-between;align-items:center;color:#111}.AccountMenu-cls2___c8b461cb4c906851c23:hover,.AccountMenu-cls2___c8b461cb4c906851c23:active,.AccountMenu-cls2___c8b461cb4c906851c23:visited{color:#111}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AccountMenu-cls1__e230c279e0c12204ac43",
	"cls2": "AccountMenu-cls2___c8b461cb4c906851c23 AccountMenu-cls1__e230c279e0c12204ac43"
};
export default ___CSS_LOADER_EXPORT___;
